import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  id: string;
  type: 'success' | 'danger' | 'warning' | 'info';
  title?: string;
  message: string;
}

export interface ValidationErrorItem {
  field?: string;
  error?: string;
}

export interface ErrorModalData {
  title: string;
  message: string;
  details?: string;
  errors?: ValidationErrorItem[];
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  toasts = signal<ToastMessage[]>([]);
  errorModalData = signal<ErrorModalData | null>(null);

  showToast(type: 'success' | 'danger' | 'warning' | 'info', message: string, title?: string) {
    const id = Math.random().toString(36).substring(2, 9);
    const toast: ToastMessage = { id, type, message, title };
    this.toasts.update(current => [...current, toast]);

    setTimeout(() => {
      this.removeToast(id);
    }, 4000);
  }

  removeToast(id: string) {
    this.toasts.update(current => current.filter(t => t.id !== id));
  }

  showErrorModal(title: string, message: string, details?: string) {
    this.errorModalData.set({ title, message, details });
  }

  handleApiError(title: string, defaultMessage: string, err: any) {
    const errorObj = err?.error || err;

    let message = defaultMessage;
    let validationErrors: ValidationErrorItem[] = [];
    let details = '';

    if (errorObj) {
      if (errorObj.Message || errorObj.message) {
        message = errorObj.Message || errorObj.message;
      }
      
      const rawErrors = errorObj.Errors || errorObj.errors;
      if (Array.isArray(rawErrors) && rawErrors.length > 0) {
        validationErrors = rawErrors.map((e: any) => ({
          field: e.Field || e.field || '',
          error: e.Error || e.error || e.message || ''
        }));
      } else if (errorObj.detail) {
        details = errorObj.detail;
      } else if (typeof errorObj === 'string') {
        details = errorObj;
      } else if (err?.message) {
        details = err.message;
      }
    }

    this.errorModalData.set({ title, message, details, errors: validationErrors });
  }

  clearErrorModal() {
    this.errorModalData.set(null);
  }
}
